import Decimal from 'decimal.js';

import {
  HypotheticalInsuranceEndsOnKind,
  HypotheticalInsuranceTransferFrequency,
} from '@/types/schema';

import { MapHypotheticalInsuranceToDataInput } from '../HypotheticalILITModal.utils';

export function getScalarFields({
  formData,
}: MapHypotheticalInsuranceToDataInput): {
  scalars: {
    displayName: string;
    /** The year this hypothetical insurance ends. Ignored if end_on_kind:YEAR is not set. */
    endYear?: number;
    /** The kind of the end date for this hypothetical insurance. */
    endsOnKind: HypotheticalInsuranceEndsOnKind;
    startYear?: number;
    transferFrequency: HypotheticalInsuranceTransferFrequency;
    transferValue: Decimal;
  } | null;
  errors?: string[];
  /** If updating, clear the end year if the endsOnKind value is not set to YEAR */
  clearEndYear: boolean;
} {
  const {
    transferName: displayName,
    endsOnKind,
    transferFrequency,
    transferValue,
    startYear,
  } = formData;

  if (!transferValue) {
    return {
      scalars: null,
      errors: ['Transfer value is required'],
      clearEndYear: false,
    };
  }

  let clearEndYear = false;
  let endYear = formData.endYear;
  if (endsOnKind !== HypotheticalInsuranceEndsOnKind.Year) {
    clearEndYear = true;
    endYear = undefined;
  }

  return {
    scalars: {
      displayName,
      endYear,
      endsOnKind,
      startYear,
      transferFrequency,
      transferValue,
    },
    clearEndYear,
  };
}
